import { useState } from "react";
import imagenError from "@/assets/img/default/defaultErrorv3.png";

interface Props {
  srcx: string;
  altx: string;
  srcDefault?: string;
}

export const ImageCart = ({ srcx, altx, srcDefault }: Props): JSX.Element => {
  const [isFalback, setIsFalback] = useState(false);
  const [loaded, setLoaded] = useState(false);

  let imagenDefault =
    srcDefault == "" || srcDefault == null ? imagenError : srcDefault;
  // Cambia a la imagen por defecto
  const handleError = () => {
    setIsFalback(!isFalback);
  };

  const handleLoader = () => setLoaded(!loaded);

  return (
    <img
      loading="lazy"
      src={
        isFalback
          ? imagenDefault
          : srcx == "" || srcx == null
          ? imagenError
          : srcx
      }
      alt={altx}
      onLoad={handleLoader}
      onError={handleError}
    />
  );
};
